import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search'
})
export class SearchPipe implements PipeTransform {
  constructor() {
  }

  transform(items: any[], searchText: string): any {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }

    searchText = searchText.toLowerCase();
    return items.filter(it => {
      console.log(it);
      return JSON.stringify(it).toLowerCase().includes(searchText);
    });
  }


}

@Pipe({
  name: 'menuFilter'
})
export class SearchMenuPipe implements PipeTransform {
  public transform(value, keys: string, term: string) {
    if (!term) { return value; }
    return (value || []).filter((item) => keys.split(',').some(key => item.hasOwnProperty(key) && new RegExp(term, 'gi').test(item[key])));

  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/search.pipe.ts